import { PropType, defineComponent, computed } from 'vue'
import styles from './styles.module.scss'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { MapViewMode } from '../../contract/map'
import PositionRender from './positionRender'
import PhoneCall from './phoneCall'
import { ChargeMapContext } from '../chargerMap/index.model'
import { Store } from 'pinia'
import SharePoster from './sharePoster'
import CountyLayoutPositionIcon from '../countyLayout/position/countyLayoutPositionIcon'
/**
 * 戳点渲染功能模块
 */
export default defineComponent({
  name: 'action-button-render-view',
  props: {
    mapInstance: {
      type: Object,
    },
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    BMapGL: {
      type: Object,
    },
    // positionVisible: {
    //   type: Boolean,
    // },
  },

  setup: (props) => {
    // 获取组件配置
    const mapInstance = computed(() => props.mapInstance)
    const componentsConfig: any = window.NSComponentsConfig
    const mapContextRef = computed(() => props.mapContextRef)
    const BMapGL = computed(() => props.BMapGL)
    const positionVisible = computed(() => {
      return props.componentStore.showHandleBox && !props.componentStore.showSummary
    })

    return () => (
      <div class={styles.actionButtonContainer}>
        {/* 分享组件 */}
        {componentsConfig?.common?.show &&
          componentsConfig.share?.show &&
          props.componentStore?.swipeIndex === 0 &&
          (props.componentStore?.viewMode === MapViewMode.Init ||
            props.componentStore?.viewMode === MapViewMode.WishPower) && (
            <SharePoster
              style={{
                visibility: positionVisible.value ? 'visible' : 'hidden',
              }}
            ></SharePoster>
          )}
        {/* 定位组件 */}
        {componentsConfig?.common?.show &&
          componentsConfig.location?.show &&
          props.componentStore?.swipeIndex === 0 &&
          (props.componentStore?.viewMode === MapViewMode.Init ||
            props.componentStore?.viewMode === MapViewMode.WishPower) && (
            <PositionRender
              style={{
                visibility: positionVisible.value ? 'visible' : 'hidden',
              }}
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              BMapGL={BMapGL.value}
              componentStore={props.componentStore}
            ></PositionRender>
          )}
        {/* 县县通获取当前城市组件定位 */}
        {props.componentStore?.viewMode === MapViewMode.CountyLayout && (
          <CountyLayoutPositionIcon></CountyLayoutPositionIcon>
        )}
        {/* 打电话组件 */}
        {componentsConfig?.common?.show &&
          componentsConfig.hotline?.show &&
          props.componentStore?.viewMode === MapViewMode.Init && (
            <PhoneCall
              style={{
                visibility: positionVisible.value ? 'visible' : 'hidden',
              }}
            />
          )}
      </div>
    )
  },
})
